enum HistoryFieldName {
  ACCOUNT_ID = "accountId",
  ACCOUNTS_ID = "accountIds",
  CONTACT_ID = "contactId",
  DEAL_LOSS_REASON_ID = "dealLossReasonId",
  DEAL_STAGE_ID = "dealStageId",
  FREQUENCY_ACCEPTED_TYPES = "crmActivityTypeId",
  FREQUENCY_INTERVAL = "cadenceInterval",
  NOTE = "note",
  FUNNEL_ID = "funnelId",
  PARENT_ACCOUNT_ID = "parentAccountId",
  PRIMARY_ACCOUNT_ID = "primaryAccountId",
  PRIMARY_CONTACT_ID = "primaryContactId",
  TERR_IDS = "terrIds",
}

export default HistoryFieldName;
